module.exports = __webpack_public_path__ + "static/media/neptune5.62029d67.svg";